var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('profile', {
    staticStyle: {
      "width": "762px",
      "margin": "auto"
    },
    attrs: {
      "is-identified": _vm.isIdentified
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7237b385","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/profile/ProfileContainer.vue
// module id = 941
// module chunks = 0